export default __webpack_public_path__ + "static/media/artists.def3d1ab.png";